import { matchPath } from "react-router-dom";
import { LIFECYCLE_EVENT_WIDGET_HOSTS } from "@features/assets-feature/routing/lifecycleRouteSegments";

/** Whether the routed lifecycle event drawer can open on this page. */
export const isLifecycleEventWidgetHost = (basePath: string): boolean =>
  Object.values(LIFECYCLE_EVENT_WIDGET_HOSTS).some(
    (path) => matchPath({ path, end: true }, basePath) !== null,
  );
